import useProfile from '@app/lib/profile/state';
export default function KlaviyoIdentify() {
    const { profile, authStatus } = useProfile()

    if (authStatus !== 'AUTHENTICATED') {
        return null;
    }

    if(typeof (window as any) === 'undefined' || typeof (window as any).klaviyo === 'undefined') {
        return null;
    }

    (window as any).klaviyo.identify({
        'email' : profile?.email,
        'first_name' : profile?.firstName,
        'last_name' : profile?.lastName,
    }).then(() => console.log('profile Identify has been completed'));
}
